export default __webpack_public_path__ + "static/media/school_guardian_azul.40059806.png";